import { createContext } from "react";
export const MediaQueryContext = createContext();
